import { render } from "./HomeLayout.vue?vue&type=template&id=69fd99ed"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/dmsfrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__